import Select from './Select';
import SelectNode from './SelectNode';

export { SHOW_ALL, SHOW_CHILD, SHOW_PARENT } from './strategies';
export var TreeNode = SelectNode;

export default Select;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/vc-tree-select/src/index.js
// module id = 444
// module chunks = 0